import { Text, Card, CardHeader, Divider, makeStyles } from '@fluentui/react-components';
import useOverviewStyles from '../styles/AgentOverviewStyles';
import { customColors, customFonts } from '../../../../styles';

const useStyles = makeStyles({
    cardContent: {
        paddingTop: '5px', // 10px would be closer to current
        paddingBottom: '15px',
    },
    capabilitiesList: {
        margin: 0,
        paddingLeft: '35px',
        color: customColors.protivitiDarkBlue,
        fontStyle: 'italic',
    },
    capabilitiesItemText: {
        fontFamily: customFonts.Lato,
        fontSize: '18px',
        lineHeight: 1.25,
    },
});

interface CapabilitiesCardProps {
    capabilities: string[] | undefined;
}

const CapabilitiesCard: React.FC<CapabilitiesCardProps> = ({ capabilities }) => {
    const styles = useStyles();
    const overviewStyles = useOverviewStyles();
    const visibleCapabilities = capabilities?.filter((capability) => capability.trim().length > 0) ?? [];

    return (
        <Card className={overviewStyles.card}>
            <CardHeader
                className={overviewStyles.cardHeader}
                header={
                    <header className={overviewStyles.header}>
                        <Text className={overviewStyles.headerTitle}>Capabilities</Text>
                        <Divider />
                    </header>
                }
            />

            <div className={styles.cardContent}>
                <ul className={styles.capabilitiesList}>
                    {visibleCapabilities.map((capability, index) => (
                        <li key={`${capability}-${index}`}>
                            <Text className={styles.capabilitiesItemText}>{capability}</Text>
                        </li>
                    ))}
                </ul>
            </div>
        </Card>
    );
};

export default CapabilitiesCard;
